import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Structura Pro",
  description:
    "Proprietary Construction Workforce Management and Scope Tracking Application",
  icons: {
    icon: "/favicon.ico",
    shortcut: "/brand/icon.png",
    apple: "/brand/icon.png",
  },
};
